import React, {ReactNode} from 'react'
import BusinessScheduleChargeComponent, {BusinessScheduleCharge} from './BusinessScheduleChargeComponent'
import {Box, FormLabel} from '@mui/material'
import {LeftRowFlexContainer} from '../../../../../styledComponents/FlexComponents'
import PPNumericField from '../../../../shared/forms/PPNumericField'
import {HKConstants} from '../../../../../HKConstants'
import {stringOrEmpty} from '../../../../../stringHelper/stringHelpers'
import {Nullable} from '../../../../../app/TypeHelpers'
import styled from 'styled-components'
import PPSelect from '../../../../shared/forms/PPSelect'
import {RESERVATION_TIME_UNIT_MINUTES_NOT0, UNIT_TIME} from '../../../../../CodeMaster'
import {addEmptyData} from '../../../../../componentHelper/selectHelper'
import {SelectChangeEvent} from '@mui/material/Select'

interface Props {
    charge: BusinessScheduleCharge
    changedChargeApplyStartTime: Nullable<number>
    changedChargeApplyStartTimeUnit: UNIT_TIME
    changedCharge: BusinessScheduleCharge
    onChargeChanged: (businessScheduleCharge: BusinessScheduleCharge) => void
    onChangedChargeChanged: (businessScheduleCharge: BusinessScheduleCharge) => void
    onChangedChargeApplyStartTime: (event: React.ChangeEvent<{ value: unknown }> | SelectChangeEvent<unknown>) => void
    onChangedChargeApplyStartTimeUnit: (event: SelectChangeEvent<unknown>) => void
    businessSchedulePattern: string
    dayOfWeek: string
}

class BusinessScheduleChargeInputForm extends React.Component<Props> {

    render(): ReactNode {
        const {
            charge,
            changedChargeApplyStartTime,
            changedChargeApplyStartTimeUnit,
            changedCharge,
            onChargeChanged,
            onChangedChargeChanged,
            onChangedChargeApplyStartTime,
            onChangedChargeApplyStartTimeUnit,
            businessSchedulePattern,
            dayOfWeek,
        } = this.props

        return (<>
            <table>
                <tbody>
                <tr>
                    <td/>
                    <td>
                        <BusinessScheduleChargeComponent
                            businessScheduleCharge={charge}
                            disabled={false}
                            showHint={true}
                            handleBusinessScheduleChargeChanged={onChargeChanged}
                            businessSchedulePattern={businessSchedulePattern}
                            dayOfWeek={dayOfWeek}
                        />
                    </td>
                </tr>
                <tr>
                    <td>
                        <FormLabel disabled={charge.fixedCharge}>
                            <LeftRowFlexContainer>
                                {changedChargeApplyStartTimeUnit === UNIT_TIME.MINUTES &&
                                    <MinutesSelect
                                        data={addEmptyData(RESERVATION_TIME_UNIT_MINUTES_NOT0.values())}
                                        value={stringOrEmpty(changedChargeApplyStartTime)}
                                        onChange={onChangedChargeApplyStartTime}
                                        disabled={charge.fixedCharge}
                                    />
                                }
                                {changedChargeApplyStartTimeUnit === UNIT_TIME.HOUR &&
                                    <HoursInput
                                        InputProps={{
                                            inputProps: {
                                                min: 1,
                                                max: HKConstants.VMN.FAC.MAX_PRICE_APPLICATION_START_TIME,
                                            },
                                        }}
                                        value={stringOrEmpty(changedChargeApplyStartTime)}
                                        onChange={onChangedChargeApplyStartTime}
                                        disabled={charge.fixedCharge}
                                    />
                                }
                                <Box marginLeft={'5px'}/>
                                <PPSelect
                                    data={UNIT_TIME.values()}
                                    value={changedChargeApplyStartTimeUnit.value}
                                    onChange={onChangedChargeApplyStartTimeUnit}
                                    disabled={charge.fixedCharge}
                                />
                                後から
                            </LeftRowFlexContainer>
                        </FormLabel>
                    </td>
                    <td>
                        <BusinessScheduleChargeComponent
                            businessScheduleCharge={changedCharge}
                            disabled={charge.fixedCharge}
                            showHint={false}
                            handleBusinessScheduleChargeChanged={onChangedChargeChanged}
                            businessSchedulePattern={businessSchedulePattern}
                            dayOfWeek={dayOfWeek}
                        />
                    </td>
                </tr>
                </tbody>
            </table>
        </>)
    }
}


const MinutesSelect = styled(PPSelect)`
  width: 60px;
`

const HoursInput = styled(PPNumericField)`
  width: 60px;
`

export default BusinessScheduleChargeInputForm
